import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from "@angular/material/dialog";
import { Customer } from "../../../../shared";
import { NgForm } from "@angular/forms";
import { Asset } from "../../../../shared/interfaces/asset";
import { AdminService } from "../../../../shared/services/admin.service";
import { AssetsService } from "../../../../shared/services/assets.service";
import { CustomerService } from "../../../../shared/services/customer.service";
import { forkJoin, Subscription } from "rxjs";

@Component({
    selector: "app-xfer-form",
    templateUrl: "./xfer-form.component.html",
    styleUrls: ["./xfer-form.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class XferFormComponent implements OnDestroy {
  @ViewChild(NgForm, { static: true }) assignmentForm: NgForm;
  adminSubscription: Subscription;
  private typeSubscription: Subscription;
  private transferSubscription: Subscription;
  typeReady = false;
  saving = false;
  errorMessage = "";
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<XferFormComponent>,
    private _adminService: AdminService,
    private _customerService: CustomerService,
    private _assetsService: AssetsService,
    public _dialog: MatDialog
  ) {
    this.name = data.asset.currentAssetOwnership?.assetName || data.asset.name || data.asset.basicName || '';
    if (data.asset.assetTypeCode) {
      this.isScout = this.isScoutType(data.asset.assetTypeCode);
      this.typeReady = true;
    } else {
      this.typeSubscription = forkJoin([
        this._assetsService.getAssetDetails(data.asset.id),
        this._assetsService.getAssetModels(),
        this._assetsService.getAssetTypes()
      ]).subscribe({ next: ([asset, models, types]) => {
        const model = models.find(item => item.id === asset.assetModelId);
        const type = types.find(item => item.id === model?.assetTypeId);
        this.isScout = this.isScoutType(type?.code || type?.basicName);
        this.typeReady = !!type;
        if (!type) { this.errorMessage = "Asset type is unavailable. Assignment cannot continue."; }
      }, error: () => this.errorMessage = 'Asset type could not be loaded. Close and reopen this dialog to try again.' });
    }
    this.adminSubscription = this._customerService.getAdminCustomers().subscribe((customers) => {
      this.customers = customers;
      if (this.data.customer) {
        this.customers = this.removeSelf(this.customers);
      }
      this.fromCustomer = data.customer;
    });
  }
  doScoutSensor: boolean = true;
  name: string = "";
  customers: Customer[] = [];
  fromCustomer: Customer;
  currentDate = new Date().getTime();
  assetToAssign: Asset;
  assetsToAssign: Asset[] = [];
  targetCustomer: Customer;
  event: EventEmitter<any> = new EventEmitter();
  submitted = false;
  isScout = false;

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.adminSubscription?.unsubscribe();
    this.typeSubscription?.unsubscribe();
    this.transferSubscription?.unsubscribe();
  }

  isScoutType(code: string): boolean {
    return /^scout(?:$|[\d.\s_-])/i.test(code || '');
  }

  removeSelf(customers: Customer[]): Customer[] {
    const refactored: Customer[] = [];
    for (let i = 0; i < customers.length; i++) {
      const customer = customers[i];
      if (this.data.customer.id.includes(customer.id)) {
        continue;
      } else {
        refactored.push(customer);
      }
    }
    return refactored;
  }

  onSubmit($event): void {
    if (!this.targetCustomer || !this.typeReady || this.saving || (this.isScout && !this.name.trim())) { return; }
    this.saving = true;
    this.errorMessage = '';
    const assignment: any = { id: this.data.asset.id };
    if (this.isScout) { assignment.scoutName = this.name.trim(); }
    this.transferSubscription = this._adminService.xferAssetToCustomer(
      this.data.asset.id, this.targetCustomer.id, [assignment], this.doScoutSensor
    ).subscribe({
      next: response => {
        this.event.emit({ data: response });
        this.dialogRef.close(true);
      },
      error: () => {
        this.saving = false;
        this.errorMessage = 'The asset could not be assigned. Please try again.';
      }
    });
  }

  public checkChanged = (event) => {
    this.doScoutSensor = event.checked;
  }

  selectedCustomer($event) {
    this.targetCustomer = $event.value;
  }

  onEvent($event) {
    console.log($event);
  }

  removeHyphens(code: string): string {
    const replaced = code.replace(/-/g, "");
    return replaced;
  }
}
